import React, { useState, useEffect } from 'react';
import '../css/Collegeactivities.css';
import { extractDataArray } from './Constants';

const CollegeActivities = () => {
  const [activities, setActivities] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [reports, setReports] = useState([]);

  const [colleges, setColleges] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [selectedCollege, setSelectedCollege] = useState(null);
  const [viewType, setViewType] = useState('activities');
  const [filteredData, setFilteredData] = useState([]);
  const [searchFieldText, setSearchFieldText] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const filtered = colleges.filter((college) =>
      college.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  }, [searchText, colleges]);

  useEffect(() => {
    if (!selectedCollege) return;

    let source = [];

    if (viewType === 'activities') source = activities;
    if (viewType === 'members') source = participants;
    if (viewType === 'reports') source = reports;

    const filtered = source
      .filter(item =>
        viewType === "reports"
          ? item.area === selectedCollege
          : item.college === selectedCollege
      )
      .filter(item =>
        Object.values(item).some(val =>
          String(val).toLowerCase().includes(searchFieldText.toLowerCase())
        )
      );

    setFilteredData(filtered);

  }, [searchFieldText, selectedCollege, viewType, activities, participants, reports]);

  const fetchData = async () => {
    try {

      const [actRes, partRes, repRes] = await Promise.all([
        fetch(`${process.env.REACT_APP_API_BASE_URL}/upcoming_events/read`),
        fetch(`${process.env.REACT_APP_API_BASE_URL}/profile/read`),
        fetch(`${process.env.REACT_APP_API_BASE_URL}/reports/read`)
      ]);

      const activitiesData = extractDataArray(await actRes.json());
      const participantsData = extractDataArray(await partRes.json());
      const reportsData = extractDataArray(await repRes.json());

      setActivities(activitiesData);
      setParticipants(participantsData);
      setReports(reportsData);

      const uniqueColleges = [...new Set([
        ...activitiesData.map(a => a.college),
        ...participantsData.map(p => p.college),
        ...reportsData.map(r => r.area)
      ].filter(Boolean))];

      setColleges(uniqueColleges);
      setFilteredData(uniqueColleges);

    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  const handleCollegeClick = (college, type) => {
    setSelectedCollege(college);
    setViewType(type);
    setSearchFieldText('');
  };

  const handleBack = () => {
    setSelectedCollege(null);
    setFilteredData(colleges);
  };

  const renderTableCell = (key, value) => {

    if (!value) return <span className="empty-cell">—</span>;

    if (typeof value === 'string' && /\.(jpe?g|png)$/i.test(value)) {
      return (
        <div className="table-img-wrapper">
          <img src={`https://ethiccraft.org/${value}`} alt={key} className="table-img" />
        </div>
      );
    }

    if (typeof value === 'string' && value.includes('.pdf')) {
      return (
        <a
          href={`https://ethiccraft.org/${value}`}
          target="_blank"
          rel="noopener noreferrer"
          className="premium-link"
        >
          View PDF
        </a>
      );
    }

    const strValue = String(value);

    if (strValue.length > 100) {
      return (
        <span className="truncated-text" title={strValue}>
          {strValue.substring(0, 100)}...
        </span>
      );
    }

    return strValue;
  };

  const formatHeader = (key) => {
    return key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  };

  return (
    <div className="main-activities-container">
      <div className="premium-report-card">

        {!selectedCollege ? (
          <>
            <div className="premium-report-header">
              <h1 className="header-title">Colleges</h1>

              <div className="search-wrapper">
                <input
                  type="text"
                  className="premium-search-input"
                  placeholder="Search colleges..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </div>

            <div className="premium-table-container">
              <table className="premium-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>College</th>
                    <th className="action-column">Activities</th>
                    <th className="action-column">Members</th>
                    <th className="action-column">Event_Reports</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredData.map((college, index) => (
                    <tr key={college}>
                      <td className="index-cell">{index + 1}</td>
                      <td className="fw-500">{college}</td>

                      <td className="action-column">
                        <button
                          className="premium-btn btn-primary"
                          onClick={() => handleCollegeClick(college, 'activities')}
                        >
                          View
                        </button>
                      </td>

                      <td className="action-column">
                        <button
                          className="premium-btn btn-secondary"
                          onClick={() => handleCollegeClick(college, 'members')}
                        >
                          View
                        </button>
                      </td>

                      <td className="action-column">
                        <button
                          className="premium-btn btn-secondary"
                          onClick={() => handleCollegeClick(college, 'reports')}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}

                  {filteredData.length === 0 && (
                    <tr>
                      <td colSpan="5" className="empty-state">
                        No colleges found.
                      </td>
                    </tr>
                  )}

                </tbody>
              </table>
            </div>

          </>
        ) : (
          <>
            <div className="premium-report-header detailed-header">

              <div className="header-left">

                <button className="premium-btn btn-back" onClick={handleBack}>
                  <span className="back-arrow">←</span> Back
                </button>

                <h3 className="header-subtitle">
                  <span className="highlight-text">
                    {viewType === 'activities'
                      ? 'Activities'
                      : viewType === 'members'
                      ? 'Members'
                      : 'Reports'}
                  </span>{" "}
                  at {selectedCollege}
                </h3>

              </div>

              <div className="search-wrapper">
                <input
                  type="text"
                  className="premium-search-input"
                  placeholder="Search records..."
                  value={searchFieldText}
                  onChange={(e) => setSearchFieldText(e.target.value)}
                />
              </div>

            </div>

            <div className="premium-table-container">
              <table className="premium-table detailed-table">
                <thead>
                  <tr>
                    {filteredData[0] &&
                      Object.keys(filteredData[0]).map((key) => (
                        <th key={key}>{formatHeader(key)}</th>
                      ))}
                  </tr>
                </thead>

                <tbody>
                  {filteredData.map((row, idx) => (
                    <tr key={idx} className={row.isShown === "0" ? 'row-hidden' : ''}>
                      {Object.entries(row).map(([key, value]) => (
                        <td key={key}>
                          <div className="cell-content">
                            {renderTableCell(key, value)}
                          </div>
                        </td>
                      ))}
                    </tr>
                  ))}

                  {filteredData.length === 0 && (
                    <tr>
                      <td colSpan="100%" className="empty-state">
                        No records match your search.
                      </td>
                    </tr>
                  )}

                </tbody>
              </table>
            </div>
          </>
        )}

      </div>
    </div>
  );
};

export default CollegeActivities;